/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import httpApi from "./httpApi";

const searchProductBrands = async (searchTerm, page, size) => {
  const response = await httpApi.get(`/v1/product/brand/search?searchTerm=${searchTerm}&page=${page}&size=${size}`);
  if (response && response.data) {
    return response.data;
  }
  return null;
};
/**
 * This method is used to Add Brand
 * */
const addProductBrand = async (requestData) => {
  const response = await httpApi.post("/v1/product/brand", requestData);
  if (response && response.data) {
    return response.data;
  }

  return null;
};
/**
 * This method is used to Edit Brand
 * */
const editProductBrand = async (id, requestData) => {
  const response = await httpApi.put(`/v1/product/brand/id/${id}`, requestData);
  if (response && response.data) {
    return response.data;
  }

  return null;
};
/**
 * This method is used to delete a Brand
 * @param id
 */
const deleteProductBrand = async (id) => {
  const response = await httpApi.delete(`/v1/product/brand/id/${id}`);
  if (response && response.data) {
    return response.data;
  }
  return null;
};
export {
  searchProductBrands,
  addProductBrand,
  editProductBrand,
  deleteProductBrand,
};
